


























import { computed, defineComponent, ref } from '@vue/composition-api';

// TODO: Adapt this component to be cross-compatible with Quiz choices

const CommonModalWithVoteDisplay = defineComponent({
  props: {
    vote: {
      default() {
        return {
          id: -1,
          choices: [],
        };
      },
    },
  },
  setup(props: any) {
    const commonModal = ref(null);
    const totalSubmitted = computed(() => {
      let result = 0;
      props.vote.choices.forEach((choice: any) => {
        result += choice.count;
      });
      return result;
    });

    return {
      totalSubmitted,
      commonModal,
      open: () => (commonModal.value as any).open(),
      close: () => (commonModal.value as any).close(),
    };
  },
});

export default CommonModalWithVoteDisplay;
